
import { controls } from "../../../../pages/controls";

const rp304 = {
  label: "Scroll",
  starting: true,
  url: "rp304",
  pageLabel: "Profit & Loss statement",
  pageType: "history",
  filter: [

    ...controls.displayText({ label: "Branch", width: "col-sm-2" }),
    ...controls.branch({ defaultValue: "assigned_branch", isReadOnly: true, isRequired: true, star: true }),
    ...controls.showData({ data: "branch_display", name: "branch_display", width: "col-sm-2" }),

    ...controls.magicDateLabel({ tab: "filter", star: true, label: "As on Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", isRequired: true, default: "sessiondate" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),




    ...controls.checkBox({ tab: "filter", label: "With Branch", name: "isWitBrabch", width: "col-sm-12", tag: "basic" }),


  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Profit & Loss",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    extraRows: {
      fields: ["debit", "credit"],
      grandtotal: { type: "fixed", displayIn: "description", val: "Grand Total", count: true },
    },
    clickable: false,
    displayColumns: [{
      Header: "GL",
      accessor: "gl"
    },
    {
      Header: "Description",
      accessor: "description",
      rwidth: "*"
    },
    {
      Header: "Credit",
      accessor: "credit",
      type: "currency",
    },
    {
      Header: "Debit",
      accessor: "debit",
      type: "currency",
    },
      // {
      //   Header: "Total",
      //   accessor: "total",
      //   type: "currency",
      //   // show: false,
      //   // formula: [
      //   //   {
      //   //     f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'credit' }, { source: 'row', field: 'debit',mult: { source: "fixed", field: 'mult', fixed: { mult: -1 } } }], resultVar: 'total'
      //   //   }
      //   // ],
      // },

    ]
  }
};

export default rp304;